import React from "react";

/** Details panel split / sidebar toggle (24×24). */
export function IconDetailsSplit24(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M10 21L10 3" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M13 3L16 3C18.7614 3 21 5.23858 21 8L21 16C21 18.7614 18.7614 21 16 21L13 21"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 3L8 3C5.23858 3 3 5.23858 3 8L3 16C3 18.7614 5.23858 21 8 21L10 21"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Inbox (24×24) — nav + history rows. */
export function IconInbox24(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M3 15H7.382C7.76044 15 8.10646 15.2137 8.276 15.552L8.723 16.447C8.89242 16.7861 9.23897 17.0002 9.618 17H14.381C14.76 17.0002 15.1066 16.7861 15.276 16.447L15.723 15.553C15.8924 15.2139 16.239 14.9998 16.618 15H21"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 3C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6C3 4.34315 4.34315 3 6 3H18Z"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M16 9.94459L8 9.94458" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** Folder (24×24) — left nav. */
export function IconFolder24(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0029 6.93794H12.5292C12.1968 6.9381 11.886 6.77315 11.6998 6.49775L10.2993 4.43389C10.1124 4.15963 9.80176 3.99587 9.46991 3.99671H4.99705C3.89202 3.99671 2.99622 4.89251 2.99622 5.99754V18.0025C2.99622 19.1076 3.89202 20.0034 4.99705 20.0034H19.0029C20.1079 20.0034 21.0037 19.1076 21.0037 18.0025V8.93877C21.0037 7.83374 20.1079 6.93794 19.0029 6.93794Z"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.99622 9.87909H9.46991C9.8007 9.87894 10.11 9.71529 10.2963 9.44191L11.6968 7.37605C11.883 7.102 12.1929 6.93791 12.5242 6.93787"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Source document (16×16) — ticket properties. */
export function IconSource16(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.276 4.276L10.3907 2.39067C10.1407 2.14067 9.80137 2 9.44804 2H4.66671C3.93004 2 3.33337 2.59667 3.33337 3.33333V12.6667C3.33337 13.4033 3.93004 14 4.66671 14H11.3334C12.07 14 12.6667 13.4033 12.6667 12.6667V5.21867C12.6667 4.86533 12.526 4.526 12.276 4.276V4.276Z"
        stroke="#405261"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12.6667 5.33333H10C9.63204 5.33333 9.33337 5.03467 9.33337 4.66667V2" stroke="#405261" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M10.13 12C10.0267 11.74 9.86599 11.506 9.66066 11.316V11.316C9.31266 10.994 8.85666 10.8147 8.38266 10.8147H7.61733C7.14333 10.8147 6.68666 10.994 6.33933 11.316V11.316C6.13333 11.506 5.97333 11.74 5.87 12"
        stroke="#405261"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.76599 7.37931C9.18906 7.80238 9.18906 8.48831 8.76599 8.91138C8.34293 9.33445 7.65699 9.33445 7.23393 8.91138C6.81086 8.48831 6.81086 7.80238 7.23393 7.37931C7.65699 6.95624 8.34293 6.95624 8.76599 7.37931"
        stroke="#405261"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Plus inside circular add control (16×16 graphic). */
export function IconPlus16(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M8.00061 3.33398V12.6686"
        stroke="#148DFD"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6681 8.00195H3.33337"
        stroke="#148DFD"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Inbox / mailbox (16×16) — History preview rows in ticket/chat details. */
export function IconInbox16(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M2 10H4.92133C5.17363 10 5.40431 10.1424 5.51733 10.368L5.81533 10.9647C5.92828 11.1907 6.15932 11.3335 6.412 11.3333H9.58733C9.84002 11.3335 10.0711 11.1907 10.184 10.9647L10.482 10.3687C10.595 10.1426 10.826 9.99988 11.0787 10H14"
        stroke="#405261"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C13.1046 2 14 2.89543 14 4V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V4C2 2.89543 2.89543 2 4 2H12Z"
        stroke="#405261"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10.6663 6.62924L5.33301 6.62923" stroke="#405261" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** Search magnifier (16×16) — conversations history modal. */
export function IconSearch16(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M11.3333 11.3333L14 14"
        stroke="#748494"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333Z"
        stroke="#748494"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Chevron down (16×16) — filter selects. */
export function IconChevronDown16(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M4.5 6.5L8 10L11.5 6.5"
        stroke="#405261"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Close X (24×24) — conversations history modal. */
export function IconClose24(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M8 8L16 16" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 8L8 16" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** Close / dismiss (16×16) — bulk selection exit. */
export function IconClose16({ stroke = "#405261", ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path d="M12 4L4 12" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 4L12 12" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** Status (16×16) — bulk Status action. */
export function IconBulkStatus16({ stroke = "#405261", ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M13.1943 4.99805C13.724 5.90956 14.0029 6.94506 14.0027 7.9993"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.99907 13.1929C4.08923 12.6659 3.33321 11.9098 2.80615 11"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0013 2.80443C10.0897 2.27477 9.05423 1.99587 8 1.99609"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 14.0013C10.1423 13.9972 12.1208 12.854 13.1942 11"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.99881 2.80469C3.14482 3.87809 2.00164 5.85655 1.99756 7.99885"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="8.00025"
        cy="7.99879"
        r="3.33472"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Flag (16×16) — bulk Priority action. */
export function IconBulkFlag16({ stroke = "#405261", ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M3.33333 13.9991V2.61914"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6668 9.34602V2.66602"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.3335 9.33428C3.3335 9.33428 3.91683 8.84961 5.66683 8.84961C7.41683 8.84961 8.5835 10.0009 10.3335 10.0009C12.0835 10.0009 12.6668 9.34961 12.6668 9.34961"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.3335 2.62133C3.3335 2.62133 3.91683 2 5.66683 2C7.41683 2 8.5835 3.15133 10.3335 3.15133C12.0835 3.15133 12.6668 2.66667 12.6668 2.66667"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** User profile (16×16) — bulk Assignee action. */
export function IconBulkAssignee16({ stroke = "#405261", ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M3.3335 13.3337C3.3335 11.6671 4.66683 10.4004 6.26683 10.4004H9.66683C11.3335 10.4004 12.6002 11.7337 12.6002 13.3337"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99999 3.46602C11.1333 4.59935 11.1333 6.39935 9.99999 7.46602C8.86666 8.53268 7.06666 8.59935 5.99999 7.46602C4.93333 6.33268 4.86666 4.53268 5.99999 3.46602C7.13333 2.39935 8.86666 2.39935 9.99999 3.46602"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Label tag (16×16) — bulk Tags action. */
export function IconBulkTag16({ stroke = "#405261", ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.38363 12.315C9.60867 12.5404 9.91405 12.6671 10.2325 12.6673C10.551 12.6675 10.8566 12.5411 11.0818 12.3159L13.6506 9.7485C13.8759 9.52335 14.0024 9.21791 14.0024 8.89941C14.0024 8.58091 13.8759 8.27547 13.6506 8.05032L9.31881 3.72051C9.06867 3.47051 8.72948 3.33008 8.37582 3.33008H5.99912C5.26243 3.33008 4.66523 3.92728 4.66523 4.66397V7.03728C4.66523 7.39068 4.80547 7.72964 5.05517 7.97973L9.38363 12.315Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.99748 5.33203V7.86469C1.99748 8.21845 2.13802 8.55773 2.38817 8.80789L6.16455 12.5843"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Selected bulk checkbox (20×20) — white box, blue stroke + check. */
export function IconBulkCheck20({ filterId = "filter0_d_bulk_check", ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <g filter={`url(#${filterId})`}>
        <rect x="2" y="1" width="16" height="16" rx="4" fill="white" />
        <rect x="2.5" y="1.5" width="15" height="15" rx="3.5" stroke="#148DFD" />
      </g>
      <path
        d="M13.3987 7L9.39867 11L7 8.6"
        stroke="#148DFD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id={filterId}
          x="0"
          y="0"
          width="20"
          height="20"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0784314 0 0 0 0 0.552941 0 0 0 0 0.992157 0 0 0 0.1 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_bulk_check" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_bulk_check" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}
